export default "__VITE_ASSET__BH36dgeI__"